// Shared helpers for the legislator profile page + tab components.

// "3" → "3rd", "11" → "11th", "22" → "22nd"
export const ordinal = (n) => {
  const v = parseInt(n, 10);
  if (isNaN(v)) return n;
  const rem100 = v % 100;
  if (rem100 >= 11 && rem100 <= 13) return `${v}th`;
  return `${v}${["th", "st", "nd", "rd"][v % 10] || "th"}`;
};

// Plain-English labels for opaque Congress.gov policy-area names.
const POLICY_AREA_LABELS = {
  "Congress": "Congress (Rules & Operations)",
  "Government Operations and Politics": "Government Operations & Politics",
  "Economics and Public Finance": "Economics & Public Finance",
  "Law": "Law (Courts & Legal System)",
  "Families": "Families & Children",
  "Social Welfare": "Social Welfare & Safety Net",
  "Sports and Recreation": "Sports & Recreation",
  "Water Resources Development": "Water Resources & Infrastructure",
  "Public Lands and Natural Resources": "Public Lands & Natural Resources",
  "Science, Technology, Communications": "Science, Tech & Communications",
  "Civil Rights and Liberties, Minority Issues": "Civil Rights & Liberties",
  "Emergency Management": "Emergency Management & Disasters",
  "Native Americans": "Native American Affairs",
  "Commerce": "Commerce & Business",
  "Finance and Financial Sector": "Finance & Banking",
  "Foreign Trade and International Finance": "Trade & International Finance",
  "International Affairs": "International Affairs & Foreign Policy",
  "Armed Forces and National Security": "Armed Forces & National Security",
  "Crime and Law Enforcement": "Crime & Law Enforcement",
  "Labor and Employment": "Labor & Employment",
  "Housing and Community Development": "Housing & Community Development",
  "Energy": "Energy & Utilities",
  "Environmental Protection": "Environmental Protection",
  "Transportation and Public Works": "Transportation & Public Works",
  "Agriculture and Food": "Agriculture & Food",
  "Arts, Culture, Religion": "Arts, Culture & Religion",
  "Animals": "Animals & Wildlife",
  "Immigration": "Immigration & Border",
  "Unassigned": "Not yet classified",
};
export const policyAreaLabel = (area) => POLICY_AREA_LABELS[area] || area;

// Radar-style status pill classes for bill rows.
export const statusPillClass = (status) =>
  status === "Enacted"
    ? "whip-pill !py-0.5 !px-2 !text-[9px] !text-emerald-300 !border-emerald-500/40 !bg-emerald-500/10"
    : status === "Passed House" || status === "Passed Senate"
    ? "whip-pill !py-0.5 !px-2 !text-[9px] !text-blue-300 !border-blue-500/40 !bg-blue-500/10"
    : "whip-pill !py-0.5 !px-2 !text-[9px]";
